<div class="chat-body-container">
  <ngx-channel-status *hasWorkspaceFeature="[WorkspaceFeatures.showStatusBanner]"></ngx-channel-status>
  @if(!selectedChannel()?.messages?.length){
  <ngx-channel-blank class="height-100"></ngx-channel-blank>
  }
  <div (scroll)="onScroll()" class="chat-body" #chatBody [ngStyle]="{ 'flex-direction': 'column-reverse' }">
    <ng-template class="chat-body__date">
      <div class="chat-body__date-box">
        {{ currentDate | date : 'MM/dd/yyyy' }}
      </div>
    </ng-template>
    <div class="chat-body__messages">
      @if (selectedChannel()?.isLoadingOldMessages && showScrollButton()) {
      <div class="chat-body__loading-scroll">
        {{ 'NGX-MESSAGING.CHAT.loadingOldMessages' | translate }}
      </div>
      } @for (message of selectedChannel()?.messages ?? []; track message.uid) { @if (!message.isDeleted) { @if ($index > 0
      && showDivider(message.createdAt, selectedChannel()!.messages![$index - 1].createdAt)) {
      <div class="chat-body__day-divider">
        <div class="chat-body__divider"></div>
        <p class="chat-body__message-content-timestamp">
          {{ message.createdAt | date : 'MM/dd/yy' }}
        </p>
        <div class="chat-body__divider"></div>
      </div>
      }
      <div class="message-container" [ngClass]="{ 'message-container-incoming': message.outcoming }">
        <ngx-message class="message" [message]="message" (linkClicked)="handleLinkClick($event)"></ngx-message>
      </div>
      } }
    </div>
    @if (showScrollButton()) {
    <button
      (click)="scrollToPosition(1)"
      class="chat-body__scroll-button"
      mat-mini-fab
      color="accent"
      matBadge="{{ selectedChannel()?.unreadMessages || null }}"
      matBadgePosition="after"
      matBadgeSize="medium">
      <mat-icon svgIcon="arrow_down"></mat-icon>
    </button>
    } @if (noHasConsent() && !selectedChannel()?.isBotMode) {
    <div class="chat-body__blocked-message">
      <mat-icon svgIcon="warning"></mat-icon>
      @if(selectedChannel()?.routing === 'WHATSAPP'){
      {{
        !selectedChannel()?.messages?.length
          ? ('NGX-MESSAGING.clickActiveToStart' | translate)
          : ('NGX-MESSAGING.conversationInactive' | translate)
      }}
      } @else {
      {{ 'NGX-MESSAGING.optedOut' | translate }}
      }
    </div>
    } @if ((selectedChannel()?.unreadMessages ?? 0) > 0) {
    <div class="chat-body__unread-message">
      <mat-icon svgIcon="eye"></mat-icon>
      {{
        'NGX-MESSAGING.unreads_message'
          | translate : { unreadMessages: $safeNavigationMigration(selectedChannel()?.unreadMessages) }
      }}
    </div>
    }

    <div class="chat-body-container__banners">
      <ngx-old-messages-banner *hasWorkspaceFeature="[WorkspaceFeatures.canUseOldMessagesBanner]"></ngx-old-messages-banner>
      <ngx-last-messages-banner
        *hasWorkspaceFeature="[WorkspaceFeatures.canUseLastMessagesBanner]"></ngx-last-messages-banner>
    </div>
  </div>
</div>
